module.exports = __webpack_public_path__ + "static/img/newFood9.ec2c165.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newFood9.png
// module id = 0MQ0
// module chunks = 2